import { Tooltip } from "@material-ui/core";
import copy from "copy-to-clipboard";
import { useState } from "react";


export default function CopyValue({ val, inner, styles,tooltipTxt,className }) {

    const [copied, setCopied] = useState(false);


    const copyVal = () => {
        copy(val);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return <>
        <Tooltip title={copied ? `${tooltipTxt} Copied` : `Copy ${tooltipTxt}`} arrow>
            <span className={className} onClick={() => copyVal()} style={{ ...styles, cursor: 'pointer' }}>
                {inner}
            </span>
        </Tooltip>
    </>
}